import React from "react";
import { NavigationLinks } from "./NavigationLinks";

export const NavigationHeaderDesktop: React.FC = () => {
  return (
    <div className="hidden md:flex items-center gap-8">
      <NavigationLinks variant="header"/>
    </div>
  );
};
